import { TabLain } from '../../app/shell/TabLain'
import type { DbLockState } from '../../db/lock'

/** The tab lock states in which another tab owns (or is taking) the device database. */
export function isTabLain(lock: DbLockState): boolean {
  return (
    lock.status === 'dipegang_tab_lain' ||
    lock.status === 'meminta' ||
    lock.status === 'dipindahkan'
  )
}

interface TabLainRouteProps {
  state: DbLockState
}

/**
 * The second-tab screen for the sign-in routes: the same "SATU sudah terbuka di tab lain"
 * the shell shows, because a login from a tab that does not hold the database would
 * write into nothing.
 */
export function TabLainRoute({ state }: TabLainRouteProps) {
  return <TabLain state={state} />
}
